import { localize } from 'mixins/helpers';
import React from 'react';
import './stats-external-client.scss';
import PartWrapper from '/react4xp/mixins/ui/part-wrapper';
import ClientIndexComponent from '/react4xp/parts/stats-external-client/components/client-index';

const StatsExternalClient = (props: any) => {
    return (
        <div className="stats-external-trade">
            <h4 className="mb-3">
                {localize('stats-external-indicators-trade', props.translations)}
            </h4>

            <ClientIndexComponent {...props} />
        </div>
    );
};

export default (props: any) => (
    <PartWrapper {...props}>
        <StatsExternalClient {...props} />
    </PartWrapper>
);
